/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface CategoryItemArgs {
  type: {
    icon: string;
    label: string;
    category: string;
  };
  onSelect(category: string): unknown;
  selectedCategory: string;
}

export default class CategoryItem extends Component<CategoryItemArgs> {
  get isActive() {
    return this.args.selectedCategory === this.args.type.category;
  }
}
